import {
  IPartNote,
  IPartNoteForm,
  mapCreatePartNotes,
  mapNotesToManagedNotes,
} from 'bom/components/AddPartNote';
import { INote } from 'core/types';

interface IProps {
  notes: INote[];
  setNotes: (value: INote[]) => void;
  isEdit?: boolean;
  onAddPartNote?: (data: IPartNoteForm) => void;
  onEditPartNote?: (data: Partial<IPartNote>) => Promise<{ success: boolean }>;
  onRemovePartNote?: (id: number) => void;
}

export const usePartNotes = ({
  notes = [],
  setNotes,
  isEdit = false,
  onAddPartNote,
  onEditPartNote,
  onRemovePartNote,
}: IProps) => {
  const onAddNote = () => async (data: IPartNoteForm) => {
    if (isEdit && onAddPartNote) {
      onAddPartNote(data);

      return;
    }

    const newQuotePartNotes = mapCreatePartNotes(data);

    const newManagedNotes = mapNotesToManagedNotes(newQuotePartNotes).map((note) => ({
      ...note,
      id: note.id || Math.random(),
    }));

    setNotes([...notes, ...newManagedNotes]);
  };

  const onDeleteNote = async (deleteNote: Partial<IPartNote>) => {
    if (isEdit && onRemovePartNote) {
      onRemovePartNote(deleteNote.id);

      return;
    }

    const newManagedNotes = notes.filter((note) => note.id !== deleteNote.id);

    setNotes(newManagedNotes);
  };

  const onEditNote = async (data: Partial<IPartNote>) => {
    if (isEdit) {
      const { success } = await onEditPartNote(data);

      return Promise.resolve({ success });
    }

    const newManagedNotes = notes.map((note) =>
      note.id === data.id ? { ...note, ...data } : note
    );

    setNotes(newManagedNotes);

    return Promise.resolve({ success: true });
  };

  return {
    onAddNote,
    onDeleteNote,
    onEditNote,
  };
};
